import { Pagination } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { DataGrid,GridToolbarColumnsButton } from "@mui/x-data-grid";
import {
    getUserData,
} from "../../Actions/common";
import { allLoginSessionsAction } from "../../Actions/loginSessions";
import {
    DataGrid_SX
} from "../../Assets/customTheme/constants";
import { CustomNoRowsOverlay } from "../../Assets/customTheme/CustomNoRowsOverlay";
import { default as CoustomTooltip, default as CustomTooltip } from "../../Assets/customTheme/customtooltip";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import {
    ITEMS_PER_PAGE_OPTIONS
} from "../../config";

import { formatDateTime } from "../Common/DateFormat";
import CustomSnackbar from "../Common/snackBar";
import renderStatusBadge from "../../utils/badges";
import { MyDeleteOutlineOutlinedIcon } from "../../Assets/svg/MyIcons";

const CustomToolbar = ({
    selectedRows,
    handleDeleteSelected,
    handleSearchApi,
    handleFilterData,
    // handleResetFilters,
    filterButtonDisabled,
    resetButtonDisabled,
    handleAddIp,
    selectedOption,
    handleChangeDropdown,
    handleResetFilters,
    disableFilterButton,
}) => {
    return (
        <div className="custom-header ">

            <div className="card border-rounded-0 fiter-card">
                <div className="card-body p-5 pb-0">
                    <div className="row">
                        <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-4 col-sm-6 mb-5">
                            <div className="input-group w-100">
                                <FormControl className="w-100">
                                    <Select
                                        displayEmpty
                                        value={selectedOption}
                                        defaultValue="today"
                                        name="dropdown"
                                        onChange={handleChangeDropdown}
                                        input={<OutlinedInput />}
                                        sx={{
                                            "& .MuiSelect-select": {
                                                padding: "12px 10px",
                                                textAlign: "start",
                                                minHeight: "1em !important",
                                            },
                                            fieldset: {
                                                borderColor:
                                                    "#e1e3ea !important",
                                                borderRadius: "0.475rem",
                                            },
                                        }}
                                    >
                                        <MenuItem value="today">Today</MenuItem>
                                        <MenuItem value="yesterday">
                                            Yesterday
                                        </MenuItem>
                                        <MenuItem value="last7days">
                                            Last 7 days
                                        </MenuItem>
                                        <MenuItem value="last15days">
                                            Last 15 days
                                        </MenuItem>
                                        <MenuItem value="last30days">
                                            Last 30 days
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="col-auto ms-auto d-flex flex-wrap gap-3 pb-5">
                            <CustomTooltip title="Filter" placement="top" arrow>
                                <span>
                                    <button
                                        className="btn text-primary btn-light btn-icon"
                                        onClick={handleFilterData}
                                        disabled={filterButtonDisabled}
                                    >
                                        <TableFilte />
                                    </button>
                                </span>
                            </CustomTooltip>
                            <CustomTooltip title="Reset" placement="top" arrow>
                                <span>
                                    <button
                                        className="btn text-primary btn-light btn-icon"
                                        onClick={handleResetFilters}
                                        disabled={resetButtonDisabled}
                                    >
                                        <TableReset />
                                    </button>
                                </span>
                            </CustomTooltip>
                            {selectedRows.length !== 0 && (
                                <CoustomTooltip
                                    title="Delete"
                                    placement="top"
                                    arrow
                                >
                                    <span>
                                        <button
                                            className="btn btn-outline-danger  btn-icon btn-outline "
                                            onClick={handleDeleteSelected}
                                            disabled={selectedRows.length === 0}
                                        >
                                            <MyDeleteOutlineOutlinedIcon />
                                        </button>
                                    </span>
                                </CoustomTooltip>
                            )}

                          <CoustomTooltip title="Column Filter" placement="top" arrow>
                  <span style={{ display: "inline-block" }}>
                    <GridToolbarColumnsButton
                      slotProps={{
                        tooltip: { title: "" },
                        button: {
                          className:
                            "btn btn-light text-primary btn-icon grid-toolbar d-flex justify-content-center align-items-center p-0",
                          style: {
                            width: "47px",
                            height: "44px",
                            minWidth: "unset",
                            borderRadius: "8px",
                          },
                          startIcon: <TableColumns />,
                        },
                      }}
                    />
                  </span>
                </CoustomTooltip>

                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="d-flex align-items-center">
                        
                    </div> */}


        </div>
    );
};

const LoginSessionsSection = ({ merchantId }) => {
    const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
    const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(true);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [selectedRows, setSelectedRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [shouldFetchData, setShouldFetchData] = useState(1);
    const [whiteListIpsData, setWhiteListIpsData] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);
    const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(
        ITEMS_PER_PAGE_OPTIONS[0]
    );

    const [disableFilterButton, setDisableResetFilter] = useState(true);

    const userData = localStorage.getItem("userData") ? getUserData() : null;


    const [selectedOption, setSelectedOption] = useState("today");
    const [startDate, setStartDate] = useState(new Date().toISOString());
    const [endDate, setEndDate] = useState(new Date().toISOString());

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const getTemplateData = useCallback(async () => {
    setLoading(true);
    await allLoginSessionsAction(
        startDate,
        endDate,
        selectedRowsPerPage,
        currentPage
    )
        .then((res) => {
            const { rows, count } = res.data.data;
            if (res?.data.status === 202) {
                setSnackbar({
                    open: true,
                    message: res?.data?.message,
                    severity: "info",
                });
                return;
            }
            setWhiteListIpsData(rows);
            setTotalRecords(count);
            setLoading(false);
        })
        .catch((error) => {
            setSnackbar({
                open: true,
                message: error.response.data.message,
                severity: "error",
            });
        });
    setLoading(false);
    }, [startDate, endDate, selectedRowsPerPage, currentPage]);

    // Now use it in useEffect with clean dependencies
    useEffect(() => {
        if (shouldFetchData) {
            getTemplateData();
            setShouldFetchData(0);
        }
    }, [shouldFetchData, getTemplateData]);


    const handlePaginationChange = (event, value) => {
        setSelectedRows([]);
        setCurrentPage(value);
        setShouldFetchData(1);
    };

    const handleResetFilters = () => {
        setLoading(true);
        setCurrentPage(1);
        setShouldFetchData(1);
        setLoading(false);
        setSelectedOption("today");
        setDisableResetFilter(false);

        const today = new Date();
        setStartDate(today.toISOString());
        setEndDate(today.toISOString());
    };

    const handleFilterData = () => {
        setLoading(true);
        setCurrentPage(1);
        setShouldFetchData(1);
        setLoading(false);
        setFilterButtonDisabled(true);
        setResetButtonDisabled(false);
    };

    const handleRowsPerPageChange = (event) => {
        setWhiteListIpsData([]);
        setSelectedRows([]);
        const newValue = parseInt(event.target.value);
        setSelectedRowsPerPage(newValue);
        setCurrentPage(1);
        setLoading(true);
        setShouldFetchData(1);
    };

    const handleChangeDropdown = (e) => {
        const option = e.target.value;
        setSelectedOption(option);

        setFilterButtonDisabled(false);
        if (option !== "today") {
            setDisableResetFilter(false);
        } else {
            setDisableResetFilter(true);
        }

        const today = new Date();
        let newStartDate = null;
        let newEndDate = null;

        if (option === "today") {
            newStartDate = new Date(today);
            newEndDate = new Date(today);
        } else if (option === "yesterday") {
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            newStartDate = new Date(yesterday);
            newEndDate = new Date(yesterday);
        } else if (option === "last7days") {
            newStartDate = new Date(today);
            newStartDate.setDate(today.getDate() - 6);
            newEndDate = new Date(today);
        } else if (option === "last15days") {
            newStartDate = new Date(today);
            newStartDate.setDate(today.getDate() - 14);
            newEndDate = new Date(today);
        } else if (option === "last30days") {
            newStartDate = new Date(today);
            newStartDate.setDate(today.getDate() - 29);
            newEndDate = new Date(today);
        }

        setStartDate(newStartDate.toISOString());
        setEndDate(newEndDate.toISOString());
    };

    const columns = [
        {
            field: "status",
            minWidth: 70,
            sortable: false,
            filterable: false,
            headerName: "Status",
            flex: 1,
            align: "center",
            headerAlign: "center",

            renderCell: (params) => {
                const statusMap = {
                    OK: { text: "OK", status: "success" },
                    // WRN: { text: "Warning", status: "warning" },
                    ERR: { text: "Error", status: "error" },
                };

                const statusKey = params.row?.status ?? "ERR";

                const { text, status } = statusMap[statusKey] || {
                    text: "Unknown",
                    status: "default",
                };

                return renderStatusBadge({ status, title: text });
            },
        },
        {
            field: "device",
            sortable: false,
            filterable: false,
            headerName: "Device",
            flex: 1,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "ipAddress",
            sortable: false,
            filterable: false,
            headerName: "IP address",
            flex: 1,
            align: "center",
            headerAlign: "center",

            renderCell: (params) => {
                return params.row.ipAddress ? (
                    <span>{params.row.ipAddress}</span>
                ) : (
                    <span>-</span>
                );
            },
        },
        {
            field: "createdAt",
            flex: 1,
            headerName: "Time",
            align: "center",
            headerAlign: "center",

            renderCell: (params) => (
                <>
                    {formatDateTime(
                        params.row.createdAt,
                        true,
                        userData?.dateFormat || "",
                        userData.timeFormat || "",
                        userData?.timeZone || ""
                    )}
                </>
            ),
            sortable: false,
        },
    ];

    return (
        <div id="kt_content_container">
            <BreadcrumbsComponent />
            {/* <div className="row g-5 mt-0">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body"> */}
            <DataGrid
                className="border-0"
                localeText={{ toolbarColumns: "" }}
                rows={whiteListIpsData}
                columns={columns}
                autoHeight
                // pagination={false}
                hideFooterRowCount={true}
                hideFooterPagination={true}
                hideFooter={true}
                loading={loading}
                slots={{
                    toolbar: CustomToolbar,
                    noRowsOverlay: CustomNoRowsOverlay,
                }}
                slotProps={{
                    toolbar: {
                        selectedRows,
                        handleFilterData,
                        handleResetFilters,
                        whiteListIpsData,
                        isMenuOpen,
                        anchorEl,
                        handleMenuClose,
                        filterButtonDisabled,
                        resetButtonDisabled,
                        selectedOption,
                        handleChangeDropdown,
                        disableFilterButton,
                    },
                }}
                // components={{
                //     loadingOverlay: () => (
                //         <div
                //             style={{
                //                 display: "flex",
                //                 alignItems: "center",
                //                 justifyContent: "center",
                //                 height: "100px",
                //             }}
                //         >
                //             <CircularProgress
                //                 color="primary"
                //                 size={24}
                //                 style={{
                //                     marginRight: 10,
                //                 }}
                //             />
                //             Loading...
                //         </div>
                //     ),
                //     noRowsOverlay: () =>
                //         loading ? null : (
                //             <div
                //                 style={{
                //                     display:
                //                         !loading &&
                //                         whiteListIpsData.length ===
                //                             0
                //                             ? "block"
                //                             : "none",
                //                     fontWeight: "bold",
                //                     textAlign: "center",
                //                     padding: "20px",
                //                 }}
                //             >
                //                 No Records Found
                //             </div>
                //         ),
                // }}
                sx={DataGrid_SX}
            />
            <div className="card-footer d-flex align-items-center justify-content-between mt-7">
                <div className="d-flex align-items-center">
                    <label className="fw-semibold me-3">
                        {"Row per page"}{" "}
                    </label>
                    <FormControl
                        variant="standard"
                        style={{
                            minWidth: 50,
                        }}
                    >
                        <Select
                            labelId="rows-per-page-label"
                            id="rows-per-page"
                            value={selectedRowsPerPage}
                            onChange={handleRowsPerPageChange}
                            label="Row per page"
                        >
                            {ITEMS_PER_PAGE_OPTIONS?.map(
                                (option) => (
                                    <MenuItem
                                        key={option}
                                        value={option}
                                    >
                                        {option}
                                    </MenuItem>
                                )
                            )}
                        </Select>
                    </FormControl>
                </div>
                {!loading && whiteListIpsData?.length > 0 ? (
                    <Pagination
                        count={Math.ceil(
                            totalRecords / selectedRowsPerPage
                        )}
                        page={currentPage}
                        onChange={(event, value) =>
                            value !== currentPage
                                ? handlePaginationChange(
                                    event,
                                    value
                                )
                                : null
                        }
                        variant="outlined"
                        shape="rounded"
                        className="custom-pagination"
                    />
                ) : null}
            </div>
            {/* </div>
                    </div>
                </div>
            </div> */}

            {/* {openModal ? (
                <AddEditIpBlocked
                    getIpData={whiteListIpsData}
                    open={openModal}
                    handleClose={handleCloseModal}
                    ipDataById={ipDataById}
                    setSnackbar={setSnackbar}
                />
            ) : null} */}

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </div>
    );
};

export default LoginSessionsSection;
